<template>
    <div>
        <tab name="5"></tab>
        <div class="btn-wrap">
            <div class="l">
                <el-radio-group v-model="dataType" style="margin-bottom: 30px;" size="small">
                    <el-radio-button :label="1">饼图</el-radio-button>
                    <el-radio-button :label="2">线图</el-radio-button>
                </el-radio-group>
            </div>
            <div v-show="false" class="r">
                <el-radio-group v-model="granularity" style="margin-bottom: 30px;" size="small" @change="fetch">
                    <el-radio-button :label="1">天</el-radio-button>
                    <el-radio-button :label="2" :disabled="during <= 7">周</el-radio-button>
                    <el-radio-button :label="3" :disabled="during <= 30">月</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div v-loading="fetchLoading" class="chart-wrap">
            <div :class="['chart-content', dataType ===1 ? 'show': '']">
                <div id="pie-container"></div>
            </div>
            <div :class="['chart-content', dataType ===2 ? 'show': '']">
                <div id="line-container"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Tab from './../../components/tab';
import { Chart } from '@antv/g2';

export default {
    components: {Tab},
    data(){
        return{
            dataType: 1,
            granularity: 1,
            during: null,
            filter: null,
            pie: null,
            line: null,
            pieData: [],
            lineData: [],
            fetchLoading: false,
        }
    },
    mounted() {
        const {timeStart, timeEnd, ...filter} = this.$route.query;

        this.parsingTime(timeStart, timeEnd);

        this.filter = {timeStart, timeEnd, ...filter};

        this.$nextTick(() => {
            this.initPie();
            this.initLine();
            this.fetch();
        });
    },
    methods:{
        parsingTime(timeStart, timeEnd) {
            if(!timeStart || !timeEnd) {
                this.granularity = 3;
                this.during = Infinity;
                return;
            }

            this.during = (new Date(timeEnd).getTime() - new Date(timeStart).getTime()) / (24 * 60 * 60 * 1000);

            if(this.during <= 30) {
                this.granularity = 1;
                return 
            }
            
            if(this.during <= 365) {
                this.granularity = 2;
                return 
            }

            this.granularity = 3;
        },
        async fetch() {
            const {filter, granularity} = this;

            this.fetchLoading = true;

            const res = await this.$request({
                url:'/sales/salescharts/activity',
                method: 'post',
                data: {...filter, granularity}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.fetchLoading = false;
            });

            const{state, msg, result} = res.data;
            
            if(state !== '1') {
                return this.$message.error(msg || '获取数据失败');
            }

            const {lineSeriesData: line, pieSeriesData: pie} = result || {};

            this.pieData = (pie || []).map(item => ({name: item.name, value: parseFloat(item.value)}));
            this.lineData = (line || []).map(item => ({time: item.name, value: parseFloat(item.value)}));

            this.update();

        },
        initPie() {
            this.pie = new Chart({container: 'pie-container',autoFit: true,height: 500});

            this.pie.coordinate('theta', {radius: 0.75});
            this.pie.tooltip({showTitle: false, showMarkers: false});
            this.pie.legend({ position: 'right'});

            this.pie
                .interval()
                .position('value')
                .color('name')
                .label('name*value', {
                    layout: { type: 'pie-spider' },
                    labelHeight: 20,
                    content: (obj) => `${obj.name} (${obj.value})`,
                    labelLine: {
                    style: {
                        lineWidth: 0.5,
                    },
                    },
                })
                .adjust('stack');

            this.pie.interaction('element-active');
        },
        initLine() {
            this.line = new Chart({container: 'line-container', autoFit: true, height: 500});

            this.line.scale({
                time: {range: [0, 1]},
                value: { min: 0, nice: true, alias: '金额(元)'}
            });
            
            this.line.axis('value', {
                label: {
                    formatter: (v) => {
                        return v.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
                    }
                },
                title: {
                    offset: 80, style: { fill: '#aaaaaa' }
                }
            });

            this.line.tooltip({ showCrosshairs: true, shared: true});

            this.line.line().position('time*value');
            this.line.point().position('time*value');
        },
        update() {
            const {pie, pieData, line, lineData} = this;

            const pieDataFilter = pieData.slice(0, 5).map(item => item ? item.name : '');

            pie.filter('name', v => pieDataFilter.includes(v));
            pie.data(pieData);
            pie.render();

            line.data(lineData);
            line.render();
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-wrap {
    display: flex;

    .l {
        flex: 1;
    }
}

.chart-wrap {
    margin-top: 20px;
}

.chart-content {
    height: 0;
    overflow: hidden;

    &.show {
        height: auto;
    }
}
</style>